import { useState, Suspense, lazy, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import * as Sentry from '@sentry/react'

const SaleElement = ({ vaType, path, isBlockedIfMcpCreated }) => {
  const { t } = useTranslation()
  const [Sale, setSale] = useState(null)
  useEffect(() => {
    try {
      const LoadedElement = lazy(() => import(`./${vaType}/${path}/${path}.jsx`))
      setSale(LoadedElement)
    } catch (error) {
      if (import.meta.env.PROD) {
        Sentry.captureException(new Error('Error loading sale element'), { extra: { error } })
      }
    }
  }, [path, vaType])

  if (!Sale) {
    return ''
  }

  if (isBlockedIfMcpCreated) {
    return <p> {t('additionalSales:common.script_mcp_already_created')} </p>
  }

  return (
    <Suspense fallback={<div>{t('common:loading')}</div>}>
      <Sale />
    </Suspense>
  )
}

export default SaleElement
